module.exports = __webpack_public_path__ + "49334129fc07f2e951c87b2c8f6fb10e.png";